import { posthog } from 'posthog-js';

// Appends PostHog distinct_id and session_id as URL hash params so the
// receiving app can bootstrap with the same identity for cross-domain stitching
export const appendPostHogParams = (url) => {
  try {
    const distinctId = posthog.get_distinct_id();
    const sessionId = posthog.get_session_id();
    if (!distinctId || !sessionId) return url;
    const urlObj = new URL(url);
    urlObj.hash = `distinct_id=${encodeURIComponent(distinctId)}&session_id=${encodeURIComponent(sessionId)}`;
    return urlObj.toString();
  } catch (e) {
    return url;
  }
};
